export default "__VITE_ASSET__Bhk$I6s3__"